/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

// Function to fetch metafields for a given variant ID


  async function fetchVariantMetafields(varId) {
    const response = await fetch('https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-ec21cb5d-1ee1-42a5-9fc5-4d3c13173ef5/default/variant_metadata', {
      method: 'POST',
      headers: {"content-type" : "application/json"},
      body: JSON.stringify({
        varId: varId
      })
    });
  
    const json = await response.json();
    //console.log(json)
    return json;
  }

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();

      this.updateAvailability();
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

      if (this.variant) {
        //console.log(this.variant.id)
        const currentUrl = window.location.href;
        console.log(currentUrl);
        const testDrawer = document.querySelectorAll("[data-from-collection]")
        if (testDrawer) {
          console.log('on drawer page.!')
        }
        else {
          console.log('not on drawer page...?')
        }
        try {
          var jsonData = document.getElementById("variantDataJson").textContent;
          // Parse it into a JavaScript object
          var variantData = JSON.parse(jsonData);
          //console.log(variantData)
          const matchingOne = variantData.formatted[this.variant.id]
          //console.log(ma)
          console.log(matchingOne.metafields)
          if (matchingOne.metafields.true_uom) {
            document.getElementById("uom_price_other").textContent = `${matchingOne.metafields.uom_other}`
            document.getElementById("uom_price").textContent = `($${matchingOne.metafields.true_uom})`


          }
          if (matchingOne.metafields.dimensions && document.getElementById("shipDimensionsTable")) {
            document.getElementById("shipDimensionsTable").textContent = `${matchingOne.metafields.dimensions}`
            document.getElementById("weightTable").textContent = `${matchingOne.metafields.weight}`

          }
          if (matchingOne.metafields.dimensions && document.getElementById("shippingWeight")) {
            document.getElementById("shippingDimensions").textContent = `${matchingOne.metafields.dimensions}`
            document.getElementById("shippingWeight").textContent = `${matchingOne.metafields.weight}`

          }
          else {
            console.log('no ship table')
          }

        }
        catch {
console.log('new one failed')
        }


        
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll('.js-option').forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll('.js-option');
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.firstElementChild.textContent === variant.options[selectorIndex];
              }
              return (
                opt.nextElementSibling.querySelector('.js-value').textContent ===
                variant.options[selectorIndex]
              );
            });

            if (optionEl) {
              updateOptionAvailability(optionEl, variant.available, !variant.available);
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
     //   console.log(JSON.stringify(this.data,null,'\t'))
        const priceCurrentEl = this.price.querySelector('.price__current');
        const var__uom = this.price.querySelector('.var__uom');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');//price__discount_div
        const discountDiv = this.price.querySelector('.price__discount_div');
        const og_price = parseFloat((this.data.formatted[this.variant.id].compareAtPrice || '').replace('$', '').replace(",","")) 
        const discountPrice = parseFloat((this.data.formatted[this.variant.id].price || '').replace('$', '').replace(",",""))
        // Update current price and original price if on sale.
        const newPrice = this.data.formatted[this.variant.id].price;
        const dollars = newPrice.split('.')[0]
        const cents = newPrice.split('.')[1]
        const trueCompareAtPrice = og_price ? og_price : discountPrice*1.05

               //console.log(JSON.stringify(this.data,null,'\t'))

       // console.log(parseFloat((this.data.formatted[this.variant.id].compareAtPrice || '').replace('$', '').replace(",","")))

        this.price.querySelector('#dollarsPrice').textContent = dollars

        this.price.querySelector('#centsPrice').textContent = cents

        const temp_list_price = this.price.querySelector('#og_list_price') 

        if (temp_list_price) {
  //        this.price.querySelector('#discountText').textContent = `- ${(((trueCompareAtPrice - discountPrice)/trueCompareAtPrice)*100).toFixed(0)}%`

          this.price.querySelector('#og_list_price').innerHTML = 
    `List price: $${trueCompareAtPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }





        //update dollars / cents
       // priceCurrentEl.textContent = this.data.formatted[this.variant.id].price;
      //  localStorage.setItem("viewed_p", this.variant.id)
        if (123 === 1234) {
                              //console.log(`discount_price: ${JSON.stringify(this.variant.id)}`)
          priceWasEl.innerHTML = `was <s>${trueCompareAtPrice.toFixed(2) || ''}</s>`;
          discountDiv.innerHTML = `<p class = "discountText">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="discount-icon" style="height: 1em; width: auto; vertical-align: middle;">
          <path d="M497.94 225.94L286.06 14.06C277.53 5.53 266.29 0 254.34 0H48C21.49 0 0 21.49 0 48v206.34c0 11.95 5.53 23.19 14.06 31.71l211.88 211.88c17.01 17.01 44.53 17.01 61.54 0l210.47-210.47c17.19-17.18 17.19-44.95 0-62.12zM112 144c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"/>
        </svg>
          You save ${(((trueCompareAtPrice - discountPrice)/trueCompareAtPrice)*100).toFixed(0)}%
    </p>`
        }
        else {

        }

 

 

        
        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.textContent = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;
      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
